import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { Helmet } from "react-helmet-async";

// Generate BreadcrumbList Schema (JSON-LD)
const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

const Breadcrumbs = ({ industry, industryTitle }) => {
  const breadcrumbItems = [
    { name: "Home", url: "https://www.modernpathai.com/", path: "/" },
    { name: "Industries", url: "https://www.modernpathai.com/industries", path: null },
    { name: industryTitle, url: `https://www.modernpathai.com/industries/${industry}`, path: `/industries/${industry}` }
  ];

  const schemaItems = breadcrumbItems.map(item => ({
    name: item.name,
    url: item.url
  }));

  return (
    <>
      {/* Breadcrumb Schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(generateBreadcrumbSchema(schemaItems))}
        </script>
      </Helmet>

      {/* Visual Breadcrumbs */}
      <nav 
        aria-label="Breadcrumb" 
        className="py-4 px-4 bg-[#0A0A0A]/50"
        data-testid="breadcrumbs"
      >
        <div className="max-w-[1400px] mx-auto">
          <ol 
            className="flex items-center gap-2 text-sm"
            itemScope 
            itemType="https://schema.org/BreadcrumbList"
          >
            {/* Home */}
            <li 
              className="flex items-center"
              itemProp="itemListElement" 
              itemScope 
              itemType="https://schema.org/ListItem"
            >
              <Link 
                to="/" 
                className="flex items-center gap-1.5 text-[#A0A0A0] hover:text-[#00FFFF] transition-colors"
                itemProp="item"
              >
                <Home className="w-4 h-4" />
                <span itemProp="name">Home</span>
              </Link>
              <meta itemProp="position" content="1" />
            </li>

            <ChevronRight className="w-4 h-4 text-[#606060]" />

            {/* Industries */}
            <li 
              className="flex items-center"
              itemProp="itemListElement" 
              itemScope 
              itemType="https://schema.org/ListItem"
            >
              <span 
                className="text-[#A0A0A0]"
                itemProp="name"
              >
                Industries
              </span>
              <meta itemProp="position" content="2" />
            </li>

            <ChevronRight className="w-4 h-4 text-[#606060]" />

            {/* Current Industry */}
            <li 
              className="flex items-center"
              itemProp="itemListElement" 
              itemScope 
              itemType="https://schema.org/ListItem"
            >
              <span 
                className="text-[#00FFFF] font-medium"
                itemProp="name"
                aria-current="page"
              >
                {industryTitle}
              </span>
              <meta itemProp="position" content="3" />
            </li>
          </ol>
        </div>
      </nav>
    </>
  );
};

export default Breadcrumbs;
